<!-- 
Expander panel showing the administrative fee calculation.
-->
<template>
  <div>
    <a
      :id="'focus-' + panelNumber"
      href="#" class="section-heading subheading d-block pl-4 pr-5 pt-3 pb-3"
      @click.stop.prevent="$emit('click:togglePanel', panelAdministrativeFeeBreakdown)"
    >
      Calculation breakdown: Administrative fee component
      <v-btn icon class="focus-button" tabindex="-1">
        <v-icon :class="'expand-icon ' + (expanded ? 'expanded' : '')">expand_more</v-icon>
      </v-btn>
    </a>
    <v-expand-transition>
      <v-card v-show="expanded" flat>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
        <div v-if="!isInternal" class="caption pl-4 pr-4 pt-2" v-html="templates.AdministrativeFeeComponent"/>
        <v-card-text class="pa-0">
          <our-data-container v-if="!administrativeFeeAmountOverridden" right fluid>
            <our-data-field label-width="3" label="Administrative fee per provider">
              {{ levyCollection.administrationFeePerProvider | currency }}
            </our-data-field>
            <our-data-field v-if="!levyParameters.isNew" label-width="3" label="Administrative fee per student * Number of students">
              {{ levyCollection.administrationFeePerStudent | currency }} * {{ levyParameters.studentCount | number }} = {{ levyCalculation.administrativeFee2 | currency }}
            </our-data-field>
            <our-data-field v-if="!levyParameters.isNew" label-width="3" label="Total administrative fee">
              {{ levyCollection.administrationFeePerProvider | currency }} 
              <span v-if="levyCalculation.lastYearsAdministrativeFee">
                + {{ levyCalculation.lastYearsAdministrativeFee | currency }}
              </span>
              + 
              {{ levyCalculation.administrativeFee2 | currency }}
              =
              <span class="title">
                {{ levyCalculation.administrativeFeeComponent | currency }}
              </span>
              <template v-slot:footer>
                <playground-up-down v-if="isLevyEstimator" field="administrativeFeeComponent" small/>
              </template>
            </our-data-field>
            <v-flex v-if="levyCalculation.lastYearsAdministrativeFee" xs12>
              <our-data-field label-width="3" label="Last year's administrative fee per provider">
                {{ levyCalculation.lastYearsAdministrativeFee | currency }}
              </our-data-field>
            </v-flex>
          </our-data-container>
          <our-data-container v-else right fluid>
            <our-data-field :label="calculationOverride.administrativeFeeComponentDescription" label-width="3">
              {{ levyCalculation.administrativeFeeComponent | currency }}
            </our-data-field>
          </our-data-container>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import mixins from "./mixins";
import PlaygroundUpDown from "@/components/levy-collection-providers/calculation/PlaygroundUpDown.vue";
import CalculationPercentage from "@/components/levy-collection-providers/calculation/CalculationPercentage.vue";

export default {
  components: {
    PlaygroundUpDown,
    CalculationPercentage
  },
  mixins: [filterMixins, mixins],
  props: {
    expanded: {
      type: Boolean,
      required: true
    },
    panelNumber: {
      type: Number,
      required: true
    }
  }
};
</script>
